import { put, all, takeEvery } from 'redux-saga/effects';
import { SEND_REGISTRATION, SEND_REGISTRATION_AFTER, SEND_REGISTRATION_AFTER_HATCH } from './constants';
import {
    sendRegistrationFormSuccess,
    sendRegistrationFormAfterSuccess,
    sendRegistrationFormAfterHatchSuccess
} from './actions';
import { sendRegistrationForm, sendRegistrationFormAfter, sendRegistrationFormAfterHatch } from './api';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, user}>>}
 */
function* sendRegForm( actionObj ) {
    const regResult = yield sendRegistrationForm( actionObj.formData );
    if ( regResult ) {
        yield put( sendRegistrationFormSuccess( regResult ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchRegForm() {
    yield takeEvery( SEND_REGISTRATION, sendRegForm );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, user}>>}
 */
function* sendRegFormAfter( actionObj ) {
    const regResult = yield sendRegistrationFormAfter( actionObj.formData );
    if ( regResult ) {
        yield put( sendRegistrationFormAfterSuccess( regResult ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, user}>>}
 */
function* sendRegFormAfterHatch( actionObj ) {
    const regResult = yield sendRegistrationFormAfterHatch( actionObj.formData );
    if ( regResult ) {
        yield put( sendRegistrationFormAfterHatchSuccess( regResult ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchRegFormAfter() {
    yield takeEvery( SEND_REGISTRATION_AFTER, sendRegFormAfter );
    yield takeEvery( SEND_REGISTRATION_AFTER_HATCH, sendRegFormAfterHatch );
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* regFormSaga() {
    yield all( [
        watchRegForm(),
        watchRegFormAfter()
    ] );
}

export default regFormSaga;
